/* eslint-disable */

import React, { useEffect } from 'react';
import {
  Route,
  Switch,
  useLocation,
  Redirect,
} from 'react-router-dom';
import _ from 'lodash';
import fixRatio from 'client/utils/fixRatio';
import history from 'client/utils/history';
import Home from 'client/containers/Home';
import Play from 'client/containers/Play';
import Search from 'client/containers/Search';
import Login from 'client/containers/Login';
import Profile from 'client/containers/Profile';
import Controls from 'client/components/Controls';

let selectableRows = null;
let listContainerELement = null;
let videoItemMarginRight = null;
let videoItemWidth = null;
let videoListHeight = null;
let tagItemMargin = null;
let tagItemWidth = null;
let tagListHeight = null;
let interviewWrapper = null;
let interviewHeight = null;
let videoLists = null;
let tagLists = null;
let paginationWrapper = null;

export default () => {
  const location = useLocation();

  useEffect(() => {
    fixRatio(checkRenderedDom);
    let canChangeScroll = true;
    window.addEventListener('keydown', (event : any) => {
      switch (event.keyCode) {
        case 38:
          return verticalMove('up');
        case 40:
          return verticalMove('down');
        case 37:
          return horizontalMove('left');
        case 39:
          return horizontalMove('right');
        case 13:
          return handleClickActiveItem();
        case 10009:
        case 187:
        case 461:
          if (
            _.get(window, ['webOS', 'platform', 'tv'])
            && (_.get(window, ['location', 'pathname'], '') === '/')
            && !_.get(window, ['location', 'search'])
          ) {
            window.webOS.platformBack();
          } else {
            history.goBack();
          }
          break;
        default:
          return null;
      }
    });
    window.addEventListener('wheel', (data : any) => {
      if (canChangeScroll) {
        if (data.wheelDeltaY < -10) {
          verticalMove('down');
        } else if (data.wheelDeltaY > 10) {
          verticalMove('up');
        }
        canChangeScroll = false;
        setTimeout(() => {
          canChangeScroll = true;
        }, 200);
      }
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      checkRenderedDom();
    }, 100);
  }, [location.pathname]);

  const checkElementHasClass = (element : any, className : string) : boolean => {
    return ((` ${element.className} `).replace(/[\n\t]/g, ' ')
      .indexOf(` ${className} `) > -1);
  };

  const checkRenderedDom = () => {
    let interval = null;

    function handleCheckRenderedDom() {
      const videoListsItems = document.getElementsByClassName('videoList');
      const videoItems = document.getElementsByClassName('videoItem');
      const tagListsItems = document.getElementsByClassName('tagList');
      const tagItems = document.getElementsByClassName('tagItem');
      const interviewWrapperElement = document.getElementsByClassName('interviewWrapper');
      const paginationWrapperElement = document.getElementsByClassName('paginationWrapper')[0];
      let videoItemMarginRightValue = 0;
      Array.from(videoItems)
        .forEach((item : any) => {
          if (
            videoItemMarginRightValue < 1 &&
            (parseInt(window.getComputedStyle(item).marginRight, 10) > 0)
          ) {
            videoItemMarginRight = parseInt(window.getComputedStyle(item).marginRight, 10);
          }
        });
      if (videoItems.length > 0) {
        selectableRows = document.getElementsByClassName('selectableRow');
        videoItemMarginRight = videoItemMarginRightValue;
        videoItemWidth = parseInt(window.getComputedStyle(videoItems[0]).width, 10);
        videoListHeight = parseInt(window.getComputedStyle(videoListsItems[0]).height, 10);
        tagItemMargin = tagItems.length > 1
          ? (parseInt(window.getComputedStyle(tagItems[1]).marginRight, 10) +
            parseInt(window.getComputedStyle(tagItems[1]).marginLeft, 10))
          : null;
        tagItemWidth = tagItems.length > 0
          ? (parseInt(window.getComputedStyle(tagItems[0]).width, 10))
          : null;
        tagListHeight = tagListsItems.length > 0
          ? parseInt(window.getComputedStyle(tagListsItems[0]).height, 10)
          : null;
        listContainerELement = document.getElementsByClassName('listsContainer')[0];
        interviewWrapper = interviewWrapperElement.length > 0 ? interviewWrapperElement[0] : null;
        interviewHeight = interviewWrapperElement.length > 0 ? window.getComputedStyle(interviewWrapperElement[0]).height : '0px';
        videoLists = videoListsItems;
        tagLists = tagListsItems;
        paginationWrapper = paginationWrapperElement;
        setTimeout(() => {
          if (interval) {
            clearInterval(interval);
          }
          document.getElementsByClassName('listsContainer')[0].style.marginTop = '0px';
        }, 100);
      }
    }

    interval = setInterval(handleCheckRenderedDom, 500);
    checkHaveActiveItem();
  };

  const checkHaveActiveItem = () : boolean => {
    const selectableRowsGroup = document.getElementsByClassName('selectableRow');
    const lastActive = document.getElementsByClassName('lastActive')[0];
    if (!selectableRows) {
      selectableRows = Array.from(selectableRowsGroup);
    }
    if (selectableRowsGroup.length > 0) {
      if (lastActive) {
        lastActive.classList.remove('lastActive', 'activeItem');
      }
      selectableRowsGroup[0].classList.add('activeRow');
      selectableRowsGroup[0].getElementsByClassName('selectableItem')[0].classList.add('activeItem', 'lastActive');
    }
    return false;
  };

  // eslint-disable-next-line
  const handleClickActiveItem = () => {
    const activeElement = document.getElementsByClassName('activeItem')[0];
    if (activeElement && !checkElementHasClass(activeElement, 'disableSelection')) {
      const route = activeElement.getAttribute('route');
      const isSeries = activeElement.getAttribute('isseries');
      const clickable = activeElement.getAttribute('clickable');
      if (clickable) {
        activeElement.click();
      }
      if (route && (route !== location.pathname)) {
        history.push({
          pathname: route,
          state: { isSeries },
        });
      }
    }
  };

  // eslint-disable-next-line
  const verticalMove = (direction) : void => {
    let canChangeActiveRow = true;
    let hasActiveRow = false;
    if (selectableRows && selectableRows.length >= 1) {
      function removeActiveItem(element : any) {
        element.classList.remove('activeRow');
        Array.from(element.getElementsByClassName('selectableItem'))
          .forEach((item : any) => {
            if (checkElementHasClass(item, 'activeItem')) {
              item.classList.remove('activeItem');
            }
          });
      }

      function handleSetActiveItemAfterActiveRowChanged(i : number, type : string) {
        let lastActiveIndex = null;
        const nextActiveIndex = type === 'increment' ? i + 1 : i - 1;
        const selectableItems = selectableRows[nextActiveIndex].getElementsByClassName('selectableItem');
        Array.from(selectableItems)
          .forEach((item : any, lastIndex : number) => {
            if (checkElementHasClass(item, 'lastActive')) {
              lastActiveIndex = lastIndex;
            }
          });
        if (lastActiveIndex) {
          selectableItems[lastActiveIndex].classList.add('activeItem');
        } else if (selectableItems.length > 0) {
          selectableItems[0].classList.add('activeItem', 'lastActive');
        }
      }

      function __HARD_CODE__scrollInSearchPage(elem, dir) {
        if (location.pathname === '/search') {
          if (dir === 'down' && elem.classList.contains('horizontal-list')) {
            document.getElementById('search-page').style.marginTop = '-200px';
          } else {
            document.getElementById('search-page').style.marginTop = '0';
          }
        }
      }

      Array.from(selectableRows)
        .forEach((item : any, i : number) => {
          function handleChangeActiveRow(type : string, nextRowIndex? : number, listType? : string) {
            const statement = type === 'increment' ? (i < (selectableRows.length - 1)) : (i > 0);
            const nextIndex = type === 'increment' ? (i + 1) : (i - 1);
            if (statement) {
              canChangeActiveRow = false;
              if (listType !== 'pagination' && (nextRowIndex || nextRowIndex === 0)) {
                listContainerELement.style.transitionDuration = '.2s';
                listContainerELement.style.marginTop = `-${listType === 'tagList' ? (nextRowIndex * tagListHeight) : ((nextRowIndex * videoListHeight) + (tagListHeight || 0))}px`;
              }
              removeActiveItem(item);
              selectableRows[nextIndex].classList.add('activeRow');
              __HARD_CODE__scrollInSearchPage(selectableRows[nextIndex], direction);
              handleSetActiveItemAfterActiveRowChanged(i, type);
            }
          }

          if (checkElementHasClass(item, 'activeRow')) {
            const activeItem = item.getElementsByClassName('activeItem');
            const selectableItems = item.getElementsByClassName('selectableItem');
            if (
              (!activeItem || activeItem.length < 1) &&
              (selectableItems && selectableItems.length > 0)
            ) {
              selectableItems[0].classList.add('activeItem');
            }
            hasActiveRow = true;
            if (direction === 'up') {
              if (canChangeActiveRow) {
                if (checkElementHasClass(item, 'horizontal-list')) {
                  const allItemsTag = _.map(Array.from([...tagLists, ...videoLists]), (item : any) => item.getAttribute('rowid'));
                  const activeIndex = allItemsTag.indexOf(((item.parentNode).parentNode).getAttribute('rowId'));
                  if ((tagLists.length > 0) && allItemsTag.indexOf(((item.parentNode).parentNode).getAttribute('rowId')) === 0) {
                    handleChangeActiveRow('decrement');
                  }
                  Array.from(videoLists)
                    .forEach((videoRow : any, j : number) => {
                      if (videoRow.getAttribute('rowid') === ((item.parentNode).parentNode).getAttribute('rowId')) {
                        const nextRowIndex = j - 1;
                        if (
                          nextRowIndex === 0 &&
                          interviewHeight &&
                          videoLists &&
                          videoLists.length > 1 &&
                          interviewWrapper
                        ) {
                          interviewWrapper.style.height = interviewHeight;
                          handleChangeActiveRow('decrement', nextRowIndex);
                        } else if (nextRowIndex >= 0 && canChangeActiveRow) {
                          handleChangeActiveRow('decrement', nextRowIndex);
                        } else if (nextRowIndex < 0) {
                          handleChangeActiveRow('decrement');
                        }
                      }
                    });
                  Array.from(tagLists)
                    .forEach((tagRow : any) => {
                      if (activeIndex > 0 && (tagRow.getAttribute('rowid') === allItemsTag[activeIndex - 1])) {
                        handleChangeActiveRow('decrement', 0, 'tagList');
                      }
                    });
                } else {
                  handleChangeActiveRow('decrement');
                }
              }
            } else if (direction === 'down') {
              if (canChangeActiveRow) {
                if (checkElementHasClass(item, 'horizontal-list')) {
                  if (videoLists && videoLists.length > 1 && interviewWrapper) {
                    interviewWrapper.style.height = '0px';
                  }
                  if (videoLists && videoLists.length > 0) {
                    Array.from(videoLists)
                      .forEach((videoRow : any, j : number) => {
                        if (videoRow.getAttribute('rowid') === ((item.parentNode).parentNode).getAttribute('rowId')) {
                          const nextRowIndex = j + 1;
                          if (nextRowIndex < videoLists.length && canChangeActiveRow) {
                            handleChangeActiveRow('increment', nextRowIndex, 'videoLists');
                          } else if (paginationWrapper && canChangeActiveRow) {
                            handleChangeActiveRow('increment', nextRowIndex, 'pagination');
                          }
                        }
                      });
                  }
                  if (tagLists && tagLists.length > 0) {
                    Array.from(tagLists)
                      .forEach((tagRow : any, j : number) => {
                        if (tagRow.getAttribute('rowid') === ((item.parentNode).parentNode).getAttribute('rowId')) {
                          const nextRowIndex = j + 1;
                          if ((videoLists && videoLists.length > 0) && canChangeActiveRow) {
                            handleChangeActiveRow('increment', nextRowIndex, 'tagList');
                          }
                        }
                      });
                  }
                } else {
                  handleChangeActiveRow('increment');
                }
              }
            }
          }
        });
      if (!hasActiveRow && (selectableRows.length > 0)) {
        if (selectableRows.length > 1) {
          selectableRows[1].classList.add('activeRow');
        } else {
          selectableRows[0].classList.add('activeRow');
        }
        verticalMove('down');
      }
    }
  };

  // eslint-disable-next-line
  const horizontalMove = (direction) : void => {
    let canChangeAtiveItem = true;

    if (selectableRows && selectableRows.length >= 1) {
      function changeActiveItem(selectableItems : any, element : any, index : number, type : string) {
        const nextItemIndex = type === 'increment' ? index + 1 : index - 1;
        element.classList.remove('lastActive', 'activeItem');
        selectableItems[nextItemIndex].classList.add('lastActive', 'activeItem');
        canChangeAtiveItem = false;
      }

      Array.from(selectableRows)
        .forEach((rowItem : any) => {
          if (checkElementHasClass(rowItem, 'activeRow')) {
            const selectableItems = rowItem.getElementsByClassName('selectableItem');
            Array.from(selectableItems)
              .forEach((item : any, i : number) => {
                if (checkElementHasClass(rowItem, 'horizontal-list')) {
                  const activeIndex = i - 1;
                  if (checkElementHasClass(item, 'activeItem')) {
                    const rowAppearItems = Math.floor((
                      /* $FlowFixMe */
                      document.getElementById('app').clientWidth / (videoItemWidth + videoItemMarginRight)
                    ) / 2);
                    if ((i > 0) && ((selectableItems.length - i) > rowAppearItems)) {
                      // eslint-disable-next-line
                      if (checkElementHasClass(rowItem.parentNode.parentNode, 'tagList')) {
                        // eslint-disable-next-line
                        rowItem.style.marginRight = `-${(direction === 'right' && activeIndex === 1) ? '0px' : `${(tagItemWidth + tagItemMargin + 2.65) * (direction === 'left' ? activeIndex : (activeIndex > 1) ? activeIndex - 1 : activeIndex)}px`}`;
                      } else {
                        // eslint-disable-next-line
                        rowItem.style.marginRight = `-${(direction === 'right' && activeIndex === 1) ? '0px' : `${(videoItemWidth + videoItemMarginRight) * (direction === 'left' ? activeIndex + 0.5 : (activeIndex > 1) ? activeIndex - 1 : activeIndex)}px`}`;
                      }
                    }
                  }
                }
                if (checkElementHasClass(item, 'activeItem') && canChangeAtiveItem) {
                  if (direction === 'right' && i > 0) {
                    changeActiveItem(selectableItems, item, i, 'decrement');
                  } else if (direction === 'left' && (i < (selectableItems.length - 1))) {
                    changeActiveItem(selectableItems, item, i, 'increment');
                  }
                }
              });
          }
        });
    }
  };

  return (
    <div className="keyControlWrapper">
      {
        !_.get(window, ['webOS', 'platform', 'tv']) && (
          <Controls
            onLeft={() => horizontalMove('left')}
            onRight={() => horizontalMove('right')}
            onUp={() => verticalMove('up')}
            onDown={() => verticalMove('down')}
            onOk={() => handleClickActiveItem()}
          />
        )
      }
      <Switch>
        <Route path="/search" component={Search} />
        <Route path="/signin" component={Login} />
        <Route path="/profile" component={Profile} />
        <Route
          path="/v/:id"
          render={({ match, ...rest } : any) => (
            <Play {...rest} match={match} />
          )}
        />
        <Route
          path="/:cat_id?/:cat_name?"
          render={({ match, ...rest } : any) => (
            <Home
              {...rest}
              checkRenderedDom={checkRenderedDom}
              verticalMove={verticalMove}
              match={match}
            />
          )}
        />
        <Redirect to="/" exact />
      </Switch>
    </div>
  );
}
